import { render } from "./PadbolForm.vue?vue&type=template&id=933ab7bc&scoped=true&ts=true"
import script from "./PadbolForm.vue?vue&type=script&lang=ts"
export * from "./PadbolForm.vue?vue&type=script&lang=ts"

import "./PadbolForm.vue?vue&type=style&index=0&id=933ab7bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-933ab7bc"]])

export default __exports__